const subjects = [
	{ name: '音乐', id: 1, slug: 'music' },
	{ name: '美术', id: 2, slug: 'art' }
]

export { subjects }
